import { NewsItem, NewsArticle } from '../types';

const API_BASE_URL = '/api/news';

/**
 * Получает список новостей с сервера.
 * Ожидается, что GET /api/news вернет массив объектов NewsItem.
 */
export const fetchNewsList = async (): Promise<NewsItem[]> => {
    try {
        const response = await fetch(API_BASE_URL);

        if (!response.ok) {
            throw new Error(`Ошибка при загрузке новостей: ${response.statusText}`);
        }

        const data: NewsItem[] = await response.json();

        // Сортируем на клиенте, если сервер не гарантирует порядок
        return data.sort(
            (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
        );
    } catch (error) {
        console.error("fetchNewsList error:", error);
        return [];
    }
};

/**
 * Получает полную статью по её id.
 * Ожидается, что GET /api/news/{newsId} вернет объект NewsArticle.
 */
export const fetchNewsArticle = async (newsId: string): Promise<NewsArticle | null> => {
    try {
        const response = await fetch(`${API_BASE_URL}/${newsId}`);

        if (response.status === 404) {
            return null;
        }

        if (!response.ok) {
            throw new Error(`Ошибка при загрузке статьи: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error("fetchNewsArticle error:", error);
        return null;
    }
};
